<template>
    <div>
        <base-task-status
            :session_id="session.id"
            task_name="comparable_transactions_sale"
            :finishedHook="handleTaskStatusFinished"
        />
    </div>
</template>


<script>
import configmixin from "@/mixins/configmixin";
import { Swal } from "@/components/utils/swal.alerts.js";

import ApiService from "@/components/utils/api.service.js"
import BaseTaskStatus from "./BaseTaskStatus.vue"

export default {
    mixins: [configmixin],
    components: {
        BaseTaskStatus
    },
    props: {
        session: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleTaskStatusFinished: function(task_status) {
            this.$store.dispatch("retrieveSessionAppraisalValue", this.session.id);
            return ApiService
                .get(`/amas/analysis/analysis/api/${this.session.id}/appraisal-comparable-recap`)
                .then(response => {
                    let data = response.data;
                    
                    let url = `/amas/analysis/${this.session.id}/transaction/sale/search`;
                    
                    if (!this.disabled) {
                        // NOTE: This is only for NLB demo, remove after! @kubeljk
                        if (this.config.NLB_DEMO_ENABLED) {
                            Swal({
                                icon: "success",
                                title: "Rezultat AVM-ja je pripravljen",
                                showCancelButton: false,
                                confirmButtonText: this.$t("general:ok"),
                                timer: 3000,
                            });
                        }

                        let tooltip = this.$t("task_details:status:transactions_match");
                        let _map = {
                            "A": this.$t("general:high"),
                            "B": this.$t("general:medium"),
                            "C": this.$t("general:low"),
                        }
                        tooltip = tooltip + ` - ${_map[data.transactions_match_label]} (${data.transactions_match_label})`;
                        return `
                                <a href="${url}">
                                    <span
                                        class="circle circle-sm bg-${data.transactions_match_css}"
                                        data-toggle="tooltip" data-original-title="${tooltip}"
                                    >
                                        <i class="fa fa-check"></i>
                                    </span>
                                </a>
                                `
                    }
                    else {
                        let tooltip = this.$t("comparable:enekretnine:tooltip");
                        return `
                                <a>
                                    <span
                                        class="disabled circle circle-sm bg-info"
                                        data-toggle="tooltip" data-original-title="${tooltip}"
                                    >
                                    ?
                                    </span>
                                </a>
                                `
                    }
                })
        }
    },
}
</script>